import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import NotFoundView from '../common/NotFoundView'
import SettingsHome from './SettingsHome'
import CatalogHome from './Catalog'
import PreferencesHome from './Preferences'
import ModelsHome from './Models'
import UsageHome from './Usage'

function Settings () {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <SecureRoute path={`${path}`} exact>
        <SettingsHome />
      </SecureRoute>
      <SecureRoute path={`${path}/catalog`} exact>
        <CatalogHome />
      </SecureRoute>
      <SecureRoute path={`${path}/preferences`} exact>
        <PreferencesHome />
      </SecureRoute>
      <SecureRoute path={`${path}/models`} exact>
        <ModelsHome />
      </SecureRoute>
      <SecureRoute path={`${path}/usage`} exact>
        <UsageHome />
      </SecureRoute>
      <SecureRoute path={`${path}/*`}>
        <NotFoundView />
      </SecureRoute>
    </Switch>
  )
}

export default Settings
